import { Box, Container, Typography, Button } from '@mui/material'
import { Link } from 'react-router-dom'
import { IconArrowLeft } from '@tabler/icons-react'
import { tokens } from '@/theme'

export default function NotFound() {
  return (
    <Box
      sx={{
        minHeight: '60vh',
        display: 'flex',
        alignItems: 'center',
        background: tokens.cream,
      }}
    >
      <Container maxWidth="sm" sx={{ textAlign: 'center', py: 10 }}>
        <Typography
          sx={{
            fontFamily: '"Poppins", system-ui, sans-serif',
            fontWeight: 900,
            fontSize: '7rem',
            lineHeight: 1,
            color: tokens.green['100'],
            mb: 1,
          }}
        >
          404
        </Typography>
        <Typography variant="h3" sx={{ mb: 1.5 }}>Page not found</Typography>
        <Typography variant="body1" sx={{ color: 'text.secondary', mb: 4 }}>
          The page you're looking for doesn't exist or has been moved.
        </Typography>
        <Button
          variant="contained"
          color="primary"
          component={Link}
          to="/"
          startIcon={<IconArrowLeft size={18} />}
        >
          Back to Home
        </Button>
      </Container>
    </Box>
  )
}
